import HomeWorkIcon from '@mui/icons-material/HomeWork';
import { resources as Requests } from "./Requests";
import { resources as Vacations } from "./Vacations";
import { resources as SickLeaves } from "./SickLeaves";
import { resources as BusinessTrip } from "./BusinessTrip";
import { resources as BusinessTripReports } from "./BusinessTripReports";
import { resources as NodeLeaves } from "./NodeLeaves";
import { tenants } from "utils/tenants";
import permissions from 'app/permissions';

export const resources = {
  isMenu: true,
  tenancies: [tenants.SU],
  icon: <HomeWorkIcon />,
  name: "Отсъствия",
  title: "Отсъствия",
  subMenu: [Requests, Vacations, SickLeaves, BusinessTrip, BusinessTripReports, NodeLeaves],
  permission: [permissions.canCreateLeaveRequests, permissions.canPreviewNodeLeaveRequests],
};
